<template>
    <div class="mt-5">
        <h1>{{ $t('views.Unexpected.1') }}</h1>
    </div>
</template>

<script>

</script>